import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
import ApiService from '../services/apiService';
import { themesMixin } from '../utils/themes';
import debounce from 'lodash/debounce';
export default {
  name: 'ViewChangePassword',
  mixins: [themesMixin],
  data: function data() {
    return {
      valid: false,
      password1: '',
      password2: '',
      marker: false,
      tenantName: null,
      passwordError: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme'])), {}, {
    token: function token() {
      return this.$route.query.token;
    },
    passwordIsValid: function passwordIsValid() {
      return this.password1 === this.password2;
    },
    passwordHasError: function passwordHasError() {
      return this.passwordError && typeof this.passwordError === 'string';
    },
    loginLogo: function loginLogo() {
      return this.themeGetLogoObject();
    },
    loginBackground: function loginBackground() {
      return this.themeGetBackground();
    },
    password2Rules: function password2Rules() {
      var _this = this;

      return [function (v) {
        return !!v && v === _this.password1 || _this.$i18n_t('accMgmt.user.pwdMissmatch');
      }];
    },
    passwordRules: function passwordRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
      }, function (v) {
        return !!v && typeof _this2.validatePassword() === 'string' || true;
      }];
    }
  }),
  mounted: function mounted() {
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
  },
  beforeDestroy: function beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.submitted = true;
      this.validate();

      if (!this.passwordIsValid) {
        this.$snack(this.$i18n_t('accMgmt.user.pwdMissmatch'), 'error');
        return;
      }

      return ApiService.resetPasswordWithToken(this.token, this.password1).then(function () {
        _this3.$snack(_this3.$i18n_t('accMgmt.user.pwdChgSuccess'), 'success');

        _this3.$store.dispatch('authentication/logout').then(function () {
          _this3.$router.push('/login');
        }).catch(function (error) {
          throw error;
        });
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('accMgmt.user.pwdChgFail'), 'error');
        }
      });
    },
    validate: function validate() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.snackbar = true;
      }
    },
    validatePassword: debounce(function () {
      var _this4 = this;

      return ApiService.validateUserPassword(this.password1, undefined, this.token).then(function (result) {
        if (typeof result === 'string') {
          var matches = result.match(/(.+?)_([0-9]+)$/); // special handling: length is encoded in error-message

          if (matches && matches.length) {
            var length = parseInt(matches[2]);
            var message = matches[1];
            _this4.passwordError = _this4.$i18n_tc("accMgmt.user.passwordErrors.".concat(message), length, {
              n: length
            });
          } else {
            _this4.passwordError = _this4.$i18n_t("accMgmt.user.passwordErrors.".concat(result));
          }
        } else {
          _this4.passwordError = null;
        }
      });
    }, 250)
  })
};